export const Content = ({ currentCommunity }: any) => {
  if (currentCommunity.logo_url) {
    return (
      <img
        loading="lazy"
        className="max-h-[2.5rem] lg:max-h-10"
        src={currentCommunity.logo_url}
        alt=""
      />
    );
  }

  if (currentCommunity.icon_url) {
    return (
      <div className="flex max-h-[2.5rem] flex-row gap-x-1 lg:max-h-10">
        <div className="box-border h-7 w-7 p-1 text-center">
          <img loading="lazy" src={currentCommunity.icon_url} alt="" />
        </div>
        <span className="text-lg font-medium">{currentCommunity.name}</span>
      </div>
    );
  }

  return (
    <span className="max-h-[2.5rem] text-lg font-medium lg:max-h-10">
      {currentCommunity.name}
    </span>
  );
};
